export const isSetTargetAutomationEvent = (automationEvent) => {
    return automationEvent.type === 'setTarget';
};
//# sourceMappingURL=set-target-automation-event.js.map